<template>
  <router-view />
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ObjectivesLayout'
})
</script>

<style lang="scss"></style>
